import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-hall-of-fame',
  templateUrl: './hall-of-fame.component.html',
  styleUrls: ['./hall-of-fame.component.scss']
})
export class HallOfFameComponent implements OnInit {
  fameList: any;
  yearsList: any;
  na = 0; 
  url = this.api.url;
  constructor(private api: ApiService) { }

  ngOnInit(): void {
    this.GetMTaxonomy();
  }
  GetMTaxonomy() {
    this.api.GetMTaxonomy('renwunianfen').subscribe(
      data => {
      this.yearsList = data.slice(1, data.length);
      this.GetfameList(this.yearsList[0].taxonomyId, 1, 20);
      }
    )
  }
  GetfameList(id:any, page: any, pageSize: any) {
    this.api.GetfameList(id , page, pageSize).subscribe (
      data => this.fameList = data.halloffameList
    )
  }
  nActive(i:any, id: any) {
    this.na = i
    this.GetfameList(id, 1, 20);
  }
}
